import { appModulesToRequiredUserRoles } from "@jugl-web/domain-resources/common/consts";
import {
  CRMChannel,
  SubscriptionPlanModuleId,
  UserRole,
} from "@jugl-web/rest-api";
import { TicketInboxFilter } from "@jugl-web/rest-api/tickets/models/common-types/TicketInboxFilter";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { ClientSupportPage } from "./ClientSupportPage";

export type ClientSupportPagesNavigationParams = {
  clientSupport: PageNavParams<never, { code?: string; ticket_id?: string }>;
  clientSupportChannel: PageNavParams<
    {
      channel: CRMChannel;
    },
    { ticket_id?: string }
  >;
  clientSupportActiveConversation: PageNavParams<
    {
      channel: CRMChannel;
      activeConversation: string;
    },
    { ticket_id?: string }
  >;
  clientSupportTickets: PageNavParams<
    {
      filter: TicketInboxFilter;
    },
    { ticket_id?: string }
  >;
};

export const clientSupportPagesNavigationConfig: ModulePagesConfig<ClientSupportPagesNavigationParams> =
  {
    clientSupport: {
      element: <ClientSupportPage />,
      path: "client-support",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
    clientSupportChannel: {
      element: <ClientSupportPage />,
      path: "client-support/:channel",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
    clientSupportActiveConversation: {
      element: <ClientSupportPage />,
      path: "client-support/:channel/:activeConversation",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
    clientSupportTickets: {
      element: <ClientSupportPage />,
      path: "client-support/tickets/:filter",
      isPrivate: true,
      requiredCXUserRoles: [UserRole.admin, UserRole.member],
      requiredUserRoles: appModulesToRequiredUserRoles.clientSupport,
      requiredModules: [SubscriptionPlanModuleId.whatsappCrm],
    },
  };
